import { Button, Flex, PasswordInput, TextInput } from "@mantine/core";
import { isEmail, isNotEmpty, useForm } from "@mantine/form";
import { useCallback } from "react";

import SvgCrossedEye from "../../components/Icons/CrossedEye.tsx";
import SvgVisibility from "../../components/Icons/Visibility.tsx";

interface Props {
  loading: boolean;
  onSubmit: (email: string, password: string) => void;
}

export const LoginForm = ({ loading, onSubmit }: Props) => {
  const form = useForm({
    validateInputOnBlur: true,
    initialValues: {
      email: "",
      password: "",
    },
    validate: {
      email: isEmail("Invalid email"),
      password: isNotEmpty("Field is required"),
    },
  });

  const handleSubmit = useCallback(() => {
    onSubmit(form.values.email, form.values.password);
  }, [form.values.email, form.values.password, onSubmit]);

  return (
    <>
      <Flex direction="column" gap={20} w="100%">
        <Flex gap={12} direction="column">
          <TextInput
            type="email"
            label="Email"
            placeholder="Enter Email"
            size="m"
            disabled={loading}
            {...form.getInputProps("email")}
          />
          <PasswordInput
            label="Password"
            placeholder="Password"
            size="m"
            disabled={loading}
            visibilityToggleIcon={({ reveal }) =>
              reveal ? <SvgCrossedEye /> : <SvgVisibility />
            }
            {...form.getInputProps("password")}
          />
        </Flex>
      </Flex>

      <Button
        variant="filledBlue"
        size="md"
        w="100%"
        disabled={!form.isValid() || loading}
        loading={loading}
        onClick={handleSubmit}
      >
        Login Now
      </Button>
    </>
  );
};
